const register = {
  loginCredentials: "Identifiants de connexion", // translated
  companyInformation: "Informations sur la société", // translated
  contactDetails: "Détails du contact", // translated
  businessName: "Nom de l'entreprise", // translated
  businessAddress: "Adresse d'affaires", // translated
  registrationCode: "Code d'enregistrement", // translated
  websiteUrl: "URL de site web", // translated
  mobilePhone: "Téléphone mobile", // translated
  regionStateProvince: "Région/État/Province", // translated
  legalTitle: "Titre légal", // translated
  city: "Ville", // translated
  postalCode: "Code Postal", // translated
  registrationSuccess: "Succès de l'inscription.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome: "Veuillez patienter quelques instants et vous serez redirigé vers la page d'accueil.", // translated
};

export default register;
